import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

export function Button({
  variant = 'secondary', className, ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      {...props}
      className={clsx(
        'inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition',
        'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-neutral-950',
        'disabled:opacity-50 disabled:pointer-events-none',
        variant === 'primary' && 'bg-white text-neutral-950 hover:bg-neutral-200 focus:ring-white',
        variant === 'secondary' && 'bg-neutral-800 text-neutral-100 hover:bg-neutral-700 focus:ring-neutral-500',
        variant === 'ghost' && 'text-neutral-300 hover:bg-neutral-800 hover:text-neutral-100',
        className,
      )}
    />
  );
}
